module.exports = __webpack_public_path__ + "static/media/G1-8-Alexxia-Liakos-cod28.c7937127.png";